import { gql } from '@apollo/client'

const ALL_MEALS = gql`
  query allMeals($pagination: Pagination, $filter: MealFilter) {
    allMeals(pagination: $pagination, filter: $filter) {
      meals {
        id
        description
        occurredAt
        generatedOccurredAt
        updatedAt
        createdAt
        favorite
        kind
        source
        title
        avatar
        ingredients {
          id
          description
          servingAmount
          servingUnits
          calories
          nutrition {
            key
            value
          }
          thirdPartyIngredientSource
          thirdPartyIngredientId
        }
        statistics {
          glucoseScore
        }
      }
    }
  }
`

export default ALL_MEALS
